import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiServices } from '@shared/lib/use-api-services';
import { useAuth } from '@entities/auth';

export const useRefreshReferralCode = () => {
  const { t } = useTranslation('cabinet');
  const services = useApiServices();
  const { refreshUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshReferralCode = async () => {
    setIsLoading(true);
    setError(null);

    try {
      await services.auth.refreshReferralCode();
      await refreshUser();
      return { success: true as const };
    } catch (err: unknown) {
      const message =
        (err as { message?: string })?.message || t('referral.codeRefreshError');
      setError(message);
      return { success: false as const, error: message };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    refreshReferralCode,
    isLoading,
    error,
  };
};
